export default __webpack_public_path__ + "static/media/TRIP_ADVISOR.54b34dab.png";